module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-01"
  }, [(!_vm.finprueba) ? _c('v-layout', {
    staticClass: "actividad-3-productos",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('ui-title-cen', {
    attrs: {
      "title": "Actividad"
    }
  }), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "mt-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": "",
      "hidden-xs-only": ""
    }
  }, [_c('image-app', {
    staticClass: "animated bounceIn dura_1",
    attrs: {
      "imaSize": 120,
      "imaSrc": 'design/red-arrow',
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated flipInX dura_1",
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.actividad.introduccion))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "hidden-xs-only": ""
    }
  }, [_c('image-app', {
    staticClass: "animated bounceIn dura_1",
    attrs: {
      "imaSize": 169,
      "imaSrc": 'design/banco8-1-2',
      "imaAlt": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": "",
      "youtubeEmbed": _vm.actividad.preguntas[_vm.pregNum].video
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "animated fadeInUp dura_2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "mt-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": "",
      "text-xs-center": ""
    }
  }, [_c('ui-circle-span', {
    attrs: {
      "tabindex": "0",
      "id": "botonej",
      "botProp": [_vm.pregNum + 1, 'circ-med', 'back-red'],
      "aria": 'Item número' + (_vm.pregNum + 1)
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('p', [_vm._v("\n          " + _vm._s(_vm.actividad.preguntas[_vm.pregNum].pregunta) + "\n        ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.finprueba) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "mt-1": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('ul', {
    staticClass: "unstyled-list",
    attrs: {
      "aria-label": "Opciones"
    }
  }, _vm._l((_vm.actividad.buttons), function(bot, index) {
    return _c('li', {
      key: index,
      staticClass: "list-actpreguntas"
    }, [_c('ui-button-circle', {
      staticClass: "animated rotateIn",
      class: 'dura_' + (index + 2),
      attrs: {
        "partOne": bot.name[0],
        "partTwo": bot.name[1],
        "partThree": bot.name[2],
        "aria": bot.arialab
      },
      nativeOn: {
        "click": function($event) {
          _vm.selOpcion(index, bot)
        }
      }
    }), _vm._v(" "), (bot.seleccionado) ? _c('div', {
      staticClass: "act-retro"
    }, [_c('image-app', {
      attrs: {
        "imaSize": 30,
        "imaSrc": bot.eval ? 'logos-icons/ok-bullet' : 'logos-icons/wrong-bullet',
        "imaAlt": ""
      }
    })], 1) : _vm._e()], 1)
  }))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "tabindex": "0",
      "id": "alerta-final"
    }
  }, [(_vm.finprueba) ? _c('ui-act-pantallafinal', {
    attrs: {
      "titleAccess": _vm.actividad.despedida[0] + _vm.actividad.despedida[1] + _vm.actividad.despedida[2]
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v(_vm._s(_vm.actividad.despedida[0])), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partTwo"
  }, [_vm._v(_vm._s(_vm.actividad.despedida[1]))]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v(_vm._s(_vm.actividad.despedida[2]))])], 2) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    ref: "modalej",
    attrs: {
      "width": "600",
      "height": "800"
    },
    model: {
      value: (_vm.dialogOne),
      callback: function($$v) {
        _vm.dialogOne = $$v
      },
      expression: "dialogOne"
    }
  }, [_c('div', [(_vm.alerta === 'bien') ? _c('v-card', {}, [(_vm.pregNum < (_vm.actividad.buttons.length - 1)) ? _c('v-flex', {
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('h3', [_vm._v("¡Muy bien!")]), _vm._v(" "), _c('ui-button', {
    staticClass: "mt-3",
    attrs: {
      "content": "Siguiente pregunta",
      "aria": "Siguiente pregunta"
    },
    nativeOn: {
      "click": function($event) {
        _vm.sigPregunta()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.pregNum >= (_vm.actividad.buttons.length - 1)) ? _c('v-flex', {
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('h3', [_vm._v("Prueba finalizada ¡Muy bien!")]), _vm._v(" "), _c('ui-button', {
    staticClass: "mt-3",
    attrs: {
      "content": "Finalizar",
      "aria": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.finalizar()
      }
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.alerta === 'mal') ? _c('v-card', {}, [_c('v-flex', {
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('h3', [_vm._v("¡Respuesta equivocada!")]), _vm._v(" "), _c('ui-button', {
    staticClass: "mt-3",
    attrs: {
      "content": "Inténtalo otra vez",
      "aria": "Inténtalo otra vez"
    },
    nativeOn: {
      "click": function($event) {
        _vm.reintentar()
      }
    }
  })], 1)], 1) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b60cb188","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actividades/act-preguntas-01.vue
// module id = 1046
// module chunks = 1